import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, createElementVNode as _createElementVNode, resolveDirective as _resolveDirective, withDirectives as _withDirectives, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-6bed7fcc"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "audit-return-box" }
const _hoisted_2 = { class: "goods-box" }
const _hoisted_3 = ["src"]
const _hoisted_4 = { class: "goods-name-box" }
const _hoisted_5 = {
  key: 0,
  class: "goods-sku"
}
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "tip-text" }, "默认按申请金额退，可以改小", -1))
const _hoisted_7 = { class: "operat-box" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ui_form_item = _resolveComponent("ui-form-item")!
  const _component_el_table_column = _resolveComponent("el-table-column")!
  const _component_el_table = _resolveComponent("el-table")!
  const _component_ui_input = _resolveComponent("ui-input")!
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_link = _resolveComponent("el-link")!
  const _component_ui_form = _resolveComponent("ui-form")!
  const _directive_loading = _resolveDirective("loading")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_ui_form, {
      ref: "form",
      "label-width": "90px",
      size: "small"
    }, {
      default: _withCtx(() => [
        _createVNode(_component_ui_form_item, {
          label: "申请金额",
          style: {"margin-bottom":"8px"}
        }, {
          default: _withCtx(() => [
            _createTextVNode(" ￥" + _toDisplayString(_ctx.data?.amount || 0), 1)
          ]),
          _: 1
        }),
        (_ctx.data?.reason)
          ? (_openBlock(), _createBlock(_component_ui_form_item, {
              key: 0,
              label: "退款原因",
              style: {"margin-bottom":"8px"}
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_ctx.data.reason), 1)
              ]),
              _: 1
            }))
          : _createCommentVNode("", true),
        (_ctx.data?.content)
          ? (_openBlock(), _createBlock(_component_ui_form_item, {
              key: 1,
              label: "申请内容",
              style: {"margin-bottom":"8px"}
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_ctx.data.content), 1)
              ]),
              _: 1
            }))
          : _createCommentVNode("", true),
        (_ctx.goodsList.length)
          ? (_openBlock(), _createBlock(_component_ui_form_item, {
              key: 2,
              label: "退款货品"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_table, {
                  data: _ctx.goodsList,
                  border: "",
                  size: "small"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_table_column, {
                      label: "商品",
                      "min-width": "180"
                    }, {
                      default: _withCtx(({ row }) => [
                        _createElementVNode("div", _hoisted_2, [
                          (row.image)
                            ? (_openBlock(), _createElementBlock("img", {
                                key: 0,
                                src: row.image
                              }, null, 8, _hoisted_3))
                            : _createCommentVNode("", true),
                          _createElementVNode("div", _hoisted_4, [
                            _createElementVNode("div", null, _toDisplayString(row.goodsName), 1),
                            (row.skuName)
                              ? (_openBlock(), _createElementBlock("div", _hoisted_5, _toDisplayString(row.skuName), 1))
                              : _createCommentVNode("", true)
                          ])
                        ])
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_el_table_column, {
                      label: "数量",
                      width: "70",
                      align: "center"
                    }, {
                      default: _withCtx(({ row }) => [
                        _createTextVNode(_toDisplayString(row.num), 1)
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }, 8, ["data"])
              ]),
              _: 1
            }))
          : _createCommentVNode("", true),
        (_ctx.isAgree)
          ? (_openBlock(), _createBlock(_component_ui_form_item, {
              key: 3,
              label: "退款金额",
              required: _ctx.isAgree,
              data: _ctx.postData.returnAmount,
              rule: _ctx.validateAmount
            }, {
              default: _withCtx(() => [
                _createVNode(_component_ui_input, {
                  modelValue: _ctx.postData.returnAmount,
                  "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.postData.returnAmount) = $event)),
                  validate: "coin"
                }, null, 8, ["modelValue"]),
                _hoisted_6
              ]),
              _: 1
            }, 8, ["required", "data", "rule"]))
          : _createCommentVNode("", true),
        _createVNode(_component_ui_form_item, { label: "回复信息" }, {
          default: _withCtx(() => [
            _createVNode(_component_el_input, {
              type: "textarea",
              rows: 3,
              maxlength: "100",
              modelValue: _ctx.postData.replyMessage,
              "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.postData.replyMessage) = $event)),
              placeholder: _ctx.isAgree ? '通过后作为微信退款原因' : '可以说明拒绝原因'
            }, null, 8, ["modelValue", "placeholder"])
          ]),
          _: 1
        }),
        _createVNode(_component_ui_form_item, { label: "" }, {
          default: _withCtx(() => [
            _createElementVNode("div", _hoisted_7, [
              _withDirectives((_openBlock(), _createBlock(_component_el_button, {
                type: "primary",
                onClick: _ctx.submit
              }, {
                default: _withCtx(() => [
                  _createTextVNode("确定")
                ]),
                _: 1
              }, 8, ["onClick"])), [
                [_directive_loading, _ctx.submitLoading]
              ]),
              _createVNode(_component_el_link, {
                onClick: _ctx.close,
                underline: false
              }, {
                default: _withCtx(() => [
                  _createTextVNode("取消")
                ]),
                _: 1
              }, 8, ["onClick"])
            ])
          ]),
          _: 1
        })
      ]),
      _: 1
    }, 512)
  ]))
}